// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"c055f88b","355":"80dd95ac","356":"b79749a5","642":"9d55d34c","808":"78962463","914":"a62755a8","974":"683195ac","997":"08f25ffa"}[chunkId] + ".chunk.js";
};